/**
 * Gardener specific to projects
 */
import Backbone from 'backbone'

import _ from 'lodash'
import * as d3 from 'd3-selection'
import Gardener from 'scoreboard/components/gardener'
import ImagePicker from 'scoreboard/components/image-picker'
import projects from 'scoreboard/projects/projects'
import streamify from 'stream-array'

var ProjectsGardener = Gardener.extend({

	forest: true,

	_url: _.constant('api/projects'),

	expandable: _.constant(false),

	interested: function({domainType}) {
		return domainType === 'project'
	},

	initialize: function(options={}) {
		Gardener.prototype.initialize.apply(this, arguments)

		this.options.contents = (selection, tree, transitions) => {
			selection.each(function (data) {
				var node = d3.select(this)

				let contents = node.selectAll('.node-contents').data(d => [d])
				let _contents = contents.enter()
					.append('div')
					.attr('class', 'node-contents')
					.merge(contents)

				_contents.selectAll('.project-image')
					.data(d => [ ImagePicker.imgSrc(tree.nodes[d.id].logoFileId, projects.LOGO)])
					.enter()
					.append('div')
					.append('img')
					.attr('class', 'project-image')
					.merge(_contents.selectAll('.project-image'))
					.attr('src', String)
					.attr('width', 24)

				_contents.selectAll('.label')
					.data(d => [d])
					.enter()
					.append('div')
					.attr('class', 'label')
					.merge(_contents.selectAll('.label'))
					.call(tree.options.label.bind(tree))

				_contents.selectAll('.label-mask')
					.data(d => [d])
					.enter()
					.append('div')
					.attr('class', 'label-mask')
			})
		}

		Backbone.on('projects', projects => this.reload(streamify(projects)))
	},

	show: function(options) {
		var self = this
		var previousSection = self.options.section
		// important: must be before _renderTree
		this._updateOptions(options)
		if (!this.tree) {
			this._renderTree()
		}
		return this
	},

	_deleteDomainObject: function(model) {
		Gardener.prototype._deleteDomainObject.apply(this, arguments)
		projects.id = _.get(this.tree.selected(), 'id')
	},

	/**
	 * @override
	 */
	_applyTreeEdit(models, options = {}) {
		// Don't patch here, must unset properties that are removed (e.g. project logo)
		this.tree.edit(models, _.extend(options,{patch:false}))
	}

})

export default ProjectsGardener

ProjectsGardener.__filename__ = 'projects/projects-gardener.js'
